import './HowToBuy.css';
import {
  FiShoppingBag,
  FiMessageCircle,
  FiStar,
  FiUserCheck,
  FiTruck,
} from 'react-icons/fi';
import { TbRulerMeasure } from 'react-icons/tb';
import { FaWhatsapp } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";

function HowToBuy()
{
  const navigate = useNavigate();

  const steps = [
{
  icon: FiShoppingBag,
  title: 'Explora el catálogo',
  description: (
    <>
      Ve a{' '}
      <a        
        className='howtobuy-allproducts'
        onClick={() => navigate("/All")}
      >
        Todos los productos
      </a>{' '}
      para ver las prendas disponibles, con fotos y descripciones detalladas.
    </>
  ),
},
  {
    icon: TbRulerMeasure,
    title: 'Consulta la tabla de medidas',
    description:
      'Cada prenda incluye una tabla para ayudarte a elegir la talla adecuada. Si tienes dudas, escríbenos.',
  },
  {
    icon: FiMessageCircle,
    title: 'Compra por WhatsApp',
    description: (
      <>
        Haz clic en el botón de Whatsapp <FaWhatsapp style={{ color: '#25D366', verticalAlign: 'middle' }} /> en la ficha del producto para hablar con nosotros, pagar y coordinar el envío.
      </>
    ),
  },
  {
    icon: FiStar,
    title: 'Personalización',
    description:
      '¿No está tu talla o quieres otra tela? Podemos fabricar bajo pedido la prenda en tu talla y elegir el print/tono que más te guste.',
  },
  {
    icon: FiUserCheck,
    title: 'Asesoría personalizada',
    description: (
      <>
        Te acompañamos vía WhatsApp <FaWhatsapp style={{ color: '#25D366', verticalAlign: 'middle' }} /> durante todo el proceso de compra para resolver tus dudas.
      </>
    ),
  },
  {
  icon: FiTruck,
  title: 'Envíos a toda Colombia',
  description:
    'Realizamos envíos a todo el país. Tu despacho puede ser el mismo día, dependiendo de la disponibilidad de la prenda.',
  },
];

  return (
    <div className="howtobuy-container">
      <h2 className="howtobuy-title">¿Cómo Comprar?</h2>
      <div className="howtobuy-grid">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <div className="howtobuy-card" key={index}>
              <div className="howtobuy-icon-wrapper">
                <Icon className="howtobuy-icon" size={36} />
              </div>
              <h2 className="howtobuy-card-title">{step.title}</h2>
              <p className="howtobuy-description">{step.description}</p>
            </div>
          );
        })}
      </div>
      <div className="howtobuy-button-wrapper">
        <button className="howtobuy-button" onClick={() => navigate("/All")}>
              Ir al catálogo
        </button>       
      </div>
    </div>
  );
};

export { HowToBuy };